import { render, staticRenderFns } from "./lectoParamsDownDis.vue?vue&type=template&id=3b8e7ac2&scoped=true"
import script from "./lectoParamsDownDis.vue?vue&type=script&lang=js"
export * from "./lectoParamsDownDis.vue?vue&type=script&lang=js"
import style0 from "./lectoParamsDownDis.vue?vue&type=style&index=0&id=3b8e7ac2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b8e7ac2",
  null
  
)

export default component.exports